<template>
	<div>
		<!-- 头部 PC -->
		<div class="pagesBox">
			
			<div class="left">
				<UserPageSidebar />
			</div>
			
			<div class="right">
				<UserPageTopBar />
				
				<!-- 内容 -->
				<div class="home_msg" v-if="$route.path!='/userPageLab/userProfile'&&$route.path!='/userPageLab/myAddr'&&$route.path!='/userPageLab/myMarks'">
					<keep-alive :include="['myAddrMsg']">
						<router-view v-if="isRouterAlive" />
					</keep-alive>
				</div>
				
				<div class="home_msg animate__animated animate__fadeInUp" v-if="$route.path=='/userPageLab/userProfile'||$route.path=='/userPageLab/myAddr'||$route.path=='/userPageLab/myMarks'">
					<div class="pageNav">
						<div class="tab-bar f-ct">
							<div
							v-for="(item, index) in tabs"
							:key="index"
							class="tab-item"
							:class="{ 'tab-item--active': activeTab === item.id }"
							@click="activeTab=item.id,link(item.linkUrl)"
							>
							<template v-if="item.id==0">{{$t('userPageL.txt11')}}</template>
							<template v-if="item.id==1">{{$t('marks.t1')}}</template>
							<template v-if="item.id==2">{{$t('userPageL.txt8')}}</template>
							</div>
						</div>
					</div>
					<keep-alive :include="['myAddrMsg']">
						<router-view v-if="isRouterAlive" />
					</keep-alive>
				</div>
				
			</div>
			
		</div>
		
		<!-- 底部 -->
		<div>
			<SiteFooter />
		</div>
		
	</div>
</template>
<script>
import SiteFooter from '@/components/siteFooter.vue'
import UserPageSidebar from '@/components/userPageSidebar'
import UserPageTopBar from '@/components/userPageTopBar'
export default {
	components:{SiteFooter,UserPageTopBar,UserPageSidebar},
	provide() {
		return {
			reload: this.reload,
		}
	},
	data(){
		return {
			isRouterAlive: true,
			// 状态
			activeTab: 0,
			tabs: [
				{txt:'个人资料',id:0,linkUrl:'/userPageLab/userProfile'},
				{txt:'唛头管理',id:1,linkUrl:'/userPageLab/myMarks'},
				{txt:'地址管理',id:2,linkUrl:'/userPageLab/myAddr'},
			],
		}
	},
	mounted() {
		if(this.$route.path=='/userPageLab/userProfile'){this.activeTab=0}
		if(this.$route.path=='/userPageLab/myMarks'){this.activeTab=1}
		if(this.$route.path=='/userPageLab/myAddr'){this.activeTab=2}
	},
	methods:{
		goLink(){
			
		},
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(() => {
				this.isRouterAlive = true;
			});
		},
	}
}
</script>
<style lang="scss">
body{
	background: #F7F2EC;
}
</style>
<style lang="scss" scoped>
.pagesBox{
	display: flex;
	background: #f8f8f8;
	.left{
		width: 260px;
	}
	.right{
		width: calc(100% - 260px);
		height: 1404px;
		padding: 24px 32px;
		padding-bottom: 0;
		.home_msg{
			height: 1260px;
			overflow: scroll;
			padding-bottom: 24px;
		}
	}
}
.pageNav{
	padding: 0 24px;
	background: #fff;
	padding-top: 32px;
	margin-top: 24px;
	border-radius: 12px 12px;
	.tab-bar{
		display: flex;
		align-items: center;
		width: 100%;
		background: #fff;
		padding: 0px 0px;
		// border-bottom: 1px solid #F0F0F0;
	}
	.tab-item {
		font-size: 18px;
		font-weight: 400;
		color: #7D7D89;
		cursor: pointer;
		transition: color 0.2s;
		white-space: nowrap;
		padding: 0 0px;
		padding-bottom: 24px;
		position: relative;
		margin-right: 64px;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			background: #0096FF;
			border-radius: 4px;
			left: 49%;
			transform: translateX(-50%);
			bottom: 0;
			transition:0.3s;
		}
		&:hover { color: #0096FF; }
		&--active {
			color: #0096FF;
			&::after{
				transition:0.3s;
				width: 100%;
			}
			font-weight: bold;
		}
	}
}
</style>